import { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleScroll = (e) => {
      if (e.target.tagName === 'A' && e.target.hash) {
        e.preventDefault();
        const element = document.querySelector(e.target.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMenuOpen(false); // Close menu on mobile after click
      }
    };
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach(anchor => anchor.addEventListener('click', handleScroll));
    return () => {
      anchors.forEach(anchor => anchor.removeEventListener('click', handleScroll));
    };
  }, []);

  return (
    <nav>
      <div className="nav-container">
        <div className="menu-toggle" onClick={toggleMenu}>
          <svg viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </div>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {['home', 'about', 'services', 'schedule', 'contact'].map(section => (
            <li key={section}>
              <a href={`#${section}`}>
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Header;